const ActivityStatus = {
  BypassedTemporarily: "BYPASSED_TEMPORARILY",
  NotStarted: "NOT_STARTED",
  InProgress: "IN_PROGRESS",
  Bypassed: "BYPASSED",
  Completed: "COMPLETED"
};
const ActivitySubStatus = {
  Overdue: "OVERDUE",
  Unsubmitted: "UNSUBMITTED",
  BypassedUntil: "BYPASSED_UNTIL",
  IpRegistry: "IP_REGISTRY",
  AwaitingPretest: "AWAITING_PRETEST",
  Excluded: "EXCLUDED",
  PretestedOut: "PRETESTED_OUT",
  InsufficientItems: "INSUFFICIENT_ITEMS",
  Unscored: "UNSCORED",
  ManuallyScored: "MANUALLY_SCORED",
  AssessmentThresholdAchieved: "ASSESSMENT_THRESHOLD_ACHIEVED",
  MaxAttemptsReached: "MAX_ATTEMPTS_REACHED",
  AdvancedWithScore: "ADVANCED_WITH_SCORE"
};
const GradeBookEntityType = {
  GradeBook: "GradeBook",
  Activity: "Activity",
  Attempt: "Attempt"
};
const GradeBookStatus = {
  Active: "ACTIVE",
  Archived: "ARCHIVED"
};
const PacingStatus = {
  Ahead: "AHEAD",
  Behind: "BEHIND",
  OnTarget: "ON_TARGET",
  WorkDueToday: "WORK_DUE_TODAY",
  Complete: "COMPLETE"
};
export {
  ActivityStatus,
  ActivitySubStatus,
  GradeBookEntityType,
  GradeBookStatus,
  PacingStatus
};
